/* eslint-disable react/display-name */
import { Suspense, lazy } from "react";
import { Navigate, useRoutes, useSearchParams } from "react-router-dom";

import MutateLoader from "../components/MutateLoader";
import { DASHBOARD_PATH, PRO_PATH } from "../constants/AppConstants";
import AuthGuard from "../guards/AuthGuard";
import GuestGuard from "../guards/GuestGuard";
import LogoOnlyLayout from "../layouts/LogoOnlyLayout";
import Page from "../components/Page";

// import TrackingDetails from "../pages/App/TrackingDetails";

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<MutateLoader />}>
      <Component {...props} />
    </Suspense>
  );
};
export function ProRouter() {
  return useRoutes([
    {
      path: `/${DASHBOARD_PATH.ROOT}`,
      element: <DashboardLayout />,
      children: [
        {
          element: (
            <Navigate
              to={`/${DASHBOARD_PATH.ROOT}/${PRO_PATH.VIEW_ONLY_PRODUCTS}`}
              replace
            />
          ),
          index: true,
        },
        {
          path: PRO_PATH.VIEW_ONLY_PRODUCTS,
          element: <MenuOnly isViewOnly={true} />,
        },
      ],
    },
    { path: "*", element: <Navigate to="/dashboard" replace /> },
  ]);
}

export default function Router({ isMenuDisplay }) {
  return useRoutes([
    {
      path: `/${DASHBOARD_PATH.ROOT}`,
      element: <DashboardLayout />,
      children: [
        {
          element: (
            <Navigate
              to={
                isMenuDisplay
                  ? `/${DASHBOARD_PATH.ROOT}/${DASHBOARD_PATH.MENU_DISPLAY}`
                  : `/${DASHBOARD_PATH.ROOT}/${DASHBOARD_PATH.LANDING}`
              }
              replace
            />
          ),
          index: true,
        },
        { path: DASHBOARD_PATH.LANDING, element: <LandingPage /> },
        {
          path: DASHBOARD_PATH.CHECK_OUT,
          element: (
            <Page title="Checkout">
              <CheckoutList />
            </Page>
          ),
        },
        { path: DASHBOARD_PATH.ADD_ADDRESS, element: <AddressScreen /> },
        // { path: DASHBOARD_PATH.ACCEPTED_SCREEN, element: <AcceptedScreen /> },
        { path: DASHBOARD_PATH.COUNTER, element: <CounterScreen /> },
        {
          path: DASHBOARD_PATH.MENU_DISPLAY,
          element: <MenuOnly isViewOnly={true} hasRedirect={true} />,
        },
        { path: DASHBOARD_PATH.MENU, element: <ProductMenu /> },
        { path: DASHBOARD_PATH.PAYMENT_ONLINE, element: <PaymentOnline /> },
        { path: DASHBOARD_PATH.PAYMENT, element: <Payment /> },
        { path: DASHBOARD_PATH.PAYMENT_MODE, element: <PaymentMode /> },
        { path: DASHBOARD_PATH.PAYMENT_STATUS, element: <PaymentStatus /> },
        { path: DASHBOARD_PATH.MODE, element: <Mode /> },
        { path: DASHBOARD_PATH.THANKYOU, element: <ThankYouScreen /> },

        // { path: DASHBOARD_PATH.ORDER, element: <TrackOrder /> },
      ],
    },
    {
      path: `/${DASHBOARD_PATH.TRACK}`,
      // element: <DashboardLayout />,
      children: [
        {
          element: (
            <Navigate
              to={`/${DASHBOARD_PATH.TRACK}/${DASHBOARD_PATH.ORDER}`}
              replace
            />
          ),
          index: true,
        },
        { path: DASHBOARD_PATH.ACCEPTED_SCREEN, element: <AcceptedScreen /> },
        { path: DASHBOARD_PATH.ORDER_STATUS, element: <OrderStatus /> },
        { path: DASHBOARD_PATH.UPI_STATUS, element: <UPIStatus /> },
        { path: DASHBOARD_PATH.ORDER, element: <TrackOrder /> },
        { path: DASHBOARD_PATH.ORDER_DETAILS, element: <TrackingDetails /> },
      ],
    },

    { path: "*", element: <Navigate to="/dashboard" replace /> },
  ]);
}

const Login = Loadable(lazy(() => import("../pages/Auth/Login")));
const DashboardLayout = Loadable(
  lazy(() => import("../layouts/DashboardLayout")),
);
const ProductMenu = Loadable(lazy(() => import("../pages/App/ProductMenu")));
const MenuOnly = Loadable(lazy(() => import("../pages/App/MenuOnly")));
const AcceptedScreen = Loadable(
  lazy(() => import("../pages/App/AcceptedScreen")),
);
const Payment = Loadable(lazy(() => import("../pages/App/Payment")));
const PaymentOnline = Loadable(lazy(() => import("../pages/App/PayOnline")));
const PaymentStatus = Loadable(
  lazy(() => import("../pages/App/PaymentStatus")),
);
const Mode = Loadable(lazy(() => import("../pages/App/Mode")));
const PaymentMode = Loadable(lazy(() => import("../pages/App/PaymentMode")));
const ThankYouScreen = Loadable(
  lazy(() => import("../pages/App/ThankYouScreen")),
);
const LandingPage = Loadable(lazy(() => import("../pages/App/LandingPage")));
const OrderStatus = Loadable(lazy(() => import("../pages/App/OrderStatus")));
const CheckoutList = Loadable(
  lazy(() => import("../sections/check-out/views/list")),
);
const UPIStatus = Loadable(lazy(() => import("../pages/App/UPIStatus")));
const Poster = Loadable(lazy(() => import("../pages/App/Poster")));
const TrackOrder = Loadable(lazy(() => import("../pages/App/TrackOrder")));
const TrackingDetails = Loadable(
  lazy(() => import("../pages/App/TrackingDetails")),
);
const CounterScreen = Loadable(
  lazy(() => import("../pages/App/CounterScreen")),
);
const AddressScreen = Loadable(
  lazy(() => import("../sections/address/views/add")),
);
// const Page404 = Loadable(lazy(() => import("../pages/Page404")));
